import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';
import {ActivityLogSortFields} from 'src/modules/profile/user/tabs/user-activity-log/typedef';

import {bulkActivityLogsStateSelector} from './user-activity-log-state.slice';

import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {BulkActionLog} from 'src/openapi/admin/models/BulkActionLog';

export const bulkActionsLogSlice = getCachedTableDataSlice<
    BulkActionLog[],
    undefined,
    ActivityLogSortFields,
    undefined
>('bulkActionLogs');

export const bulkActivityLogsActions = bulkActionsLogSlice.actions;
export const bulkActivityLogsCacheSelector: CachedTableCacheSelector<BulkActionLog[]>
    = state => state.userPage.tabs.userActivityLogs.result.cache;
export const bulkActivityLogsDataSelector: CachedTableDataSelector<BulkActionLog[]>
    = state => state.userPage.tabs.userActivityLogs.result;
export const bulkActivityLogsResultSelector = getCachedTableResultSelector(
    bulkActivityLogsCacheSelector,
    bulkActivityLogsStateSelector,
);
